// @flow
import React from 'react';
import type {Node} from 'react';
import moment from 'moment';
import {Theme} from '@wellstone-solutions/common';
import type {UIMemberBasicType, UIStaffType} from '@wellstone-solutions/common';
import {Typography} from '@wellstone-solutions/web';
import {useStores} from 'hooks/useStores';
import type {UISessionDocumentType} from '../../model/types';
import {DATE_TIME_FORMAT} from 'modules/documentation/constants';
import {RevertedDetailRow} from './RevertedDetailRow';
import {CompletedRow} from 'modules/integration/components/CompletedRow';
import {EHRStatusView} from 'modules/integration/components';
import {DOCUMENT_STATUSES} from '../../constants';
import {getStatusDate} from '../../utils';

type PropTypes = {
  member: UIMemberBasicType,
  staff: UIStaffType,
  documentation: UISessionDocumentType,
};

export const Header = ({member, staff, documentation}: PropTypes): Node => {
  const {meStore} = useStores();

  const orgIntegration = meStore.ehrIntegrationOption;

  const isReverted = (documentation.reverted?.changedAt.length ?? 0) > 0;

  const isNewDocument = documentation.status === DOCUMENT_STATUSES.created;

  const statusDate = isNewDocument
    ? moment().format(DATE_TIME_FORMAT)
    : getStatusDate({documentation, format: DATE_TIME_FORMAT});

  const timeLabel = isNewDocument ? 'Created' : 'Last Modified';

  return (
    <>
      <Typography
        variant="h5"
        sx={{color: Theme.colorPalette.darkest, mb: Theme.spacing.micro}}>
        Session Documentation
      </Typography>
      <CompletedRow label="Peer" value={meStore.me.name} />
      {orgIntegration && (
        <EHRStatusView
          orgIntegration={orgIntegration}
          integrations={staff?.integrations}
        />
      )}
      {!isReverted && <CompletedRow label={timeLabel} value={statusDate} />}

      <RevertedDetailRow documentation={documentation} />
    </>
  );
};
